import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop"]
  static values = { frameId: String, reload: { type: Boolean, default: false } }

  connect() {
    this.handleEscape = this.closeOnEscape.bind(this)
    this.handleFrameLoad = this.onFrameLoad.bind(this)

    document.addEventListener("keydown", this.handleEscape)
    document.addEventListener("turbo:frame-load", this.handleFrameLoad)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
    document.removeEventListener("turbo:frame-load", this.handleFrameLoad)
    document.body.classList.remove("overflow-hidden")
  }

  onFrameLoad(event) {
    if (this.hasFrameIdValue && event.target.id === this.frameIdValue) {
      this.open()
    }
  }

  open() {
    document.body.classList.add("overflow-hidden")

    // Show backdrop
    this.backdropTarget.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
    })

    // Slide panel in
    this.panelTarget.classList.remove("pointer-events-none")
    requestAnimationFrame(() => {
      this.panelTarget.classList.remove("translate-x-full")
    })
  }

  close(event) {
    if (event) event.preventDefault()

    // Slide panel out
    this.panelTarget.classList.add("translate-x-full")

    // Fade backdrop out
    this.backdropTarget.classList.add("opacity-0")

    setTimeout(() => {
      this.backdropTarget.classList.add("hidden")
      this.panelTarget.classList.add("pointer-events-none")
      document.body.classList.remove("overflow-hidden")
    }, 300)
  }

  // Close without cancelling the click, so a link that opens a different
  // slideover (e.g. "Edit details" inside the payments panel) still navigates
  // and the two panels don't end up stacked at the same z-index.
  dismiss() {
    this.close()
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.backdropTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      this.close()
      if (this.reloadValue) {
        setTimeout(() => {
          window.Turbo.visit(window.location.href)
        }, 300)
      }
    }
  }
}
